/*!
 * devextreme-angular-test
 * Version: 17.2.8
 * Build date: Mon Feb 05 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */


import {
    Component,
    NgModule,
    Host,
    SkipSelf,
    Input,
    ContentChildren,
    forwardRef,
    QueryList
} from '@angular/core';



import { NestedOptionHost } from '../../core/nested-option';
import { CollectionNestedOption } from '../../core/nested-option';
import { DxiLocationComponent } from './location-dxi';



export class DxiRouteComponent extends CollectionNestedOption {
    
    get color(): string {
        return this._getOption('color');
    }
    set color(value: string) {
        this._setOption('color', value);
    }

    
    get locations(): Array<any|
        { lat?: number, lng?: number }> {
        return this._getOption('locations');
    }
    set locations(value: Array<any|
        { lat?: number, lng?: number }>) {
        this._setOption('locations', value);
    }

    
    get mode(): string {
        return this._getOption('mode');
    }
    set mode(value: string) {
        this._setOption('mode', value);
    }

    
    get opacity(): number {
        return this._getOption('opacity');
    }
    set opacity(value: number) {
        this._setOption('opacity', value);
    }

    
    get weight(): number {
        return this._getOption('weight');
    }
    set weight(value: number) {
        this._setOption('weight', value);
    }

    protected get _optionPath() {
        return 'routes';
    }


    
    get locationsChildren(): QueryList<DxiLocationComponent> {
        return this._getOption('locations');
    }
    set locationsChildren(value) {
        this.setChildren('locations', value);
    }

    constructor(  parentOptionHost: NestedOptionHost,
             optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'dxi-route',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NestedOptionHost, decorators: [{ type: SkipSelf }, { type: Host }, ]},
{type: NestedOptionHost, decorators: [{ type: Host }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'color': [{ type: Input },],
'locations': [{ type: Input },],
'mode': [{ type: Input },],
'opacity': [{ type: Input },],
'weight': [{ type: Input },],
'locationsChildren': [{ type: ContentChildren, args: [forwardRef(() => DxiLocationComponent), ] },],
};
}


export class DxiRouteModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    DxiRouteComponent
  ],
  exports: [
    DxiRouteComponent
  ],
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
